__turbopack_context__.v({
  "className": "axiformafont_a1ea6f1-module__wqTRsq__className",
});
